// eslint-disable-next-line import/no-unresolved
import { api } from '~config/api';

const getCurrentUser = () => api.get('v1/admin/admin_users/me');

export default {
  getCurrentUser
};
